const state = {
  inCreateShopProcess: false,
  showCreatShopDialog: false
}

const mutations = {
  setInCreateShopProcess (state, status) {
    state.inCreateShopProcess = status
  },
  setShowCreatShopDialog (state, status) {
    state.showCreatShopDialog = status
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
